webpackJsonp([3],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unmountQuestionGroupBuilder = exports.renderQuestionGroupBuilder = undefined;
	
	__webpack_require__(120);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(22);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _QuestionBuilder = __webpack_require__(679);
	
	var _QuestionBuilder2 = _interopRequireDefault(_QuestionBuilder);
	
	var _Messages = __webpack_require__(119);
	
	var _Messages2 = _interopRequireDefault(_Messages);
	
	var _MessageDefinitions = __webpack_require__(96);
	
	var _MessageDefinitions2 = _interopRequireDefault(_MessageDefinitions);
	
	var _Locale = __webpack_require__(118);
	
	var _reactIntl = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function render(nodeId) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      groupKey = _ref.groupKey,
	      _ref$rows = _ref.rows,
	      rows = _ref$rows === undefined ? [] : _ref$rows,
	      toggle = _ref.toggle,
	      _ref$showAll = _ref.showAll,
	      showAll = _ref$showAll === undefined ? false : _ref$showAll,
	      _ref$initialRows = _ref.initialRows,
	      initialRows = _ref$initialRows === undefined ? [] : _ref$initialRows,
	      _ref$messages = _ref.messages,
	      customMessages = _ref$messages === undefined ? {} : _ref$messages;
	
	  var mountNode = document.getElementById(nodeId);
	  var messages = _Messages2.default.get(_MessageDefinitions2.default, customMessages);
	  var answers = initialRows.length ? initialRows : [{}];
	  var questionRows = rows.length ? rows : [{}];
	
	  questionRows.forEach(function (questionRow) {
	    if (questionRow.questions) {
	      questionRow.questions.forEach(function (question) {
	        question.answer = null;
	      });
	    }
	  });
	
	  window.ignite.getAnswerService().then(function (answerService) {
	    _reactDom2.default.render(_react2.default.createElement(
	      _reactIntl.IntlProvider,
	      { locale: (0, _Locale.getLocale)(), messages: messages },
	      _react2.default.createElement(_QuestionBuilder2.default, {
	        groupKey: groupKey,
	        questionRows: questionRows,
	        toggle: toggle,
	        showAllRows: showAll,
	        initialRows: answers,
	        answerService: answerService
	      })
	    ), mountNode);
	  });
	}
	
	function renderQuestionGroupBuilder(builderId, params) {
	  render(builderId, params);
	}
	
	function unmountQuestionGroupBuilder(builderId) {
	  _reactDom2.default.unmountComponentAtNode(document.getElementById(builderId));
	}
	
	if (window.ignite) {
	  window.ignite.renderQuestionGroupBuilder = renderQuestionGroupBuilder;
	
	  window.ignite.unmountQuestionGroupBuilder = unmountQuestionGroupBuilder;
	}
	
	exports.renderQuestionGroupBuilder = renderQuestionGroupBuilder;
	exports.unmountQuestionGroupBuilder = unmountQuestionGroupBuilder;

/***/ },

/***/ 96:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  addRow: {
	    id: 'questionBuilder.addRow',
	    description: 'Message for adding a goal',
	    defaultMessage: 'New Goal'
	  },
	  prompt: {
	    id: 'questionBuilder.prompt',
	    description: 'The default message prompt for selecting your goal.',
	    defaultMessage: 'What is your goal?'
	  },
	  validationRequired: {
	    id: 'questionBuilder.validation.required',
	    description: 'The default required validation message',
	    defaultMessage: 'Please provide an answer.'
	  },
	  validationBetween: {
	    id: 'questionBuilder.validation.between',
	    description: 'The min/max required validation message',
	    defaultMessage: 'Amount must be between {min} and {max}'
	  },
	  validationMinimum: {
	    id: 'questionBuilder.validation.minimum',
	    description: 'The minimum required validation message',
	    defaultMessage: 'Amount must be more than {min}'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ 181:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BuildCheckboxOptions = exports.BuildRadioOptions = exports.BuildSelectOptions = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BuildSelectOptions = function BuildSelectOptions(options) {
	  return options.map(function (_ref) {
	    var key = _ref.key,
	        value = _ref.value;
	
	    return _react2.default.createElement(
	      'option',
	      { key: key, value: key },
	      value
	    );
	  });
	};
	
	var BuildRadioOptions = function BuildRadioOptions(options) {
	  var rowKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  var questionKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	  var valueChanged = arguments[3];
	  var answer = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "";
	
	  return options.map(function (_ref2) {
	    var key = _ref2.key,
	        value = _ref2.value;
	
	    return _react2.default.createElement(
	      'label',
	      { htmlFor: rowKey + '.' + questionKey + '.' + key, className: 'custom-control', key: rowKey + '.' + questionKey + '.' + key },
	      _react2.default.createElement('input', { className: 'answer custom-control-input radio', name: rowKey + '.' + questionKey, id: rowKey + '.' + questionKey + '.' + key, type: 'radio', onChange: valueChanged, value: key, checked: key === answer }),
	      _react2.default.createElement(
	        'span',
	        { className: 'indicator' },
	        _react2.default.createElement('span', { className: 'fa' })
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'answerLabel custom-control-description' },
	        value
	      )
	    );
	  });
	};
	
	var BuildCheckboxOptions = function BuildCheckboxOptions(options) {
	  var rowKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  var questionKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	  var valueChanged = arguments[3];
	  var answers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	
	  var answerSet = answers ? answers : [];
	  return options.map(function (_ref3) {
	    var key = _ref3.key,
	        value = _ref3.value;
	
	    return _react2.default.createElement(
	      'label',
	      { htmlFor: rowKey + '.' + questionKey + '.' + key, className: 'custom-control', key: rowKey + '.' + questionKey + '.' + key },
	      _react2.default.createElement('input', { className: 'answer custom-control-input checkbox', name: rowKey + '.' + questionKey, id: rowKey + '.' + questionKey + '.' + key, type: 'checkbox', onChange: valueChanged, value: key, checked: answerSet.includes(key) }),
	      _react2.default.createElement(
	        'span',
	        { className: 'indicator' },
	        _react2.default.createElement('span', { className: 'fa' })
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'answerLabel custom-control-description' },
	        value
	      )
	    );
	  });
	};
	
	exports.BuildSelectOptions = BuildSelectOptions;
	exports.BuildRadioOptions = BuildRadioOptions;
	exports.BuildCheckboxOptions = BuildCheckboxOptions;

/***/ },

/***/ 679:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(54);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _toConsumableArray2 = __webpack_require__(183);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _set = __webpack_require__(377);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _getPrototypeOf = __webpack_require__(27);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(29);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(28);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp, _initialiseProps;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _QuestionRow = __webpack_require__(680);
	
	var _MessageDefinitions = __webpack_require__(96);
	
	var _MessageDefinitions2 = _interopRequireDefault(_MessageDefinitions);
	
	var _reactIntl = __webpack_require__(10);
	
	var _reactFontawesome = __webpack_require__(31);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _classnames = __webpack_require__(38);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(214);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuestionBuilder = (_temp = _class = function (_React$Component) {
	  (0, _inherits3.default)(QuestionBuilder, _React$Component);
	
	  function QuestionBuilder(props) {
	    (0, _classCallCheck3.default)(this, QuestionBuilder);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (QuestionBuilder.__proto__ || (0, _getPrototypeOf2.default)(QuestionBuilder)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var showAllRows = props.showAllRows,
	        _props$initialRows = props.initialRows,
	        initialRows = _props$initialRows === undefined ? [{}] : _props$initialRows,
	        questionRows = props.questionRows;
	
	    var activeRows = initialRows;
	    if (showAllRows) {
	      activeRows = questionRows.map(function (row) {
	        var foundRow = initialRows.find(function (r) {
	          return r.questionRow && r.questionRow.key === row.key;
	        });
	        return {
	          questionRow: foundRow ? foundRow.questionRow : row,
	          checked: !!foundRow
	        };
	      });
	    }
	
	    _this.state = {
	      activeRows: activeRows
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(QuestionBuilder, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          questionRows = _props.questionRows,
	          toggle = _props.toggle,
	          showAllRows = _props.showAllRows;
	      var activeRows = this.state.activeRows;
	
	
	      var selectedRows = new _set2.default(activeRows.filter(function (t) {
	        return t.questionRow;
	      }).map(function (t) {
	        return t.questionRow.key;
	      }));
	
	      var availableRowOptions = questionRows.filter(function (_ref) {
	        var key = _ref.key;
	
	        if (key === toggle) {
	          return selectedRows.size === 0;
	        } else {
	          return !selectedRows.has(key);
	        }
	      });
	
	      var renderedQuestionRows = activeRows.map(function (row, index) {
	        /*A row has been added in the dropdown mode*/
	        var rowAdded = function rowAdded(value) {
	          console.log('adding row: ' + value);
	          row.questionRow = questionRows.find(function (r) {
	            return r.key === value;
	          });
	          var newRows = [];
	          if (value === toggle) {
	            newRows = [row];
	            questionRows.filter(function (r) {
	              return r.key !== toggle;
	            }).forEach(_this2.removeQuestionRowValues);
	          } else {
	            newRows = [].concat((0, _toConsumableArray3.default)(activeRows));
	          }
	          _this2.saveQuestionRows(newRows);
	          _this2.setState({
	            activeRows: newRows
	          });
	        };
	        /*A row has been removed from the dropdown mode options*/
	        var rowRemoved = function rowRemoved() {
	          console.log('removing row: ' + row.key);
	          activeRows.splice(index, 1);
	          _this2.removeQuestionRowValues(row.questionRow);
	          _this2.saveQuestionRows(activeRows);
	          _this2.setState({
	            activeRows: activeRows.length ? [].concat((0, _toConsumableArray3.default)(activeRows)) : [{}]
	          });
	        };
	        /*A row has been toggled in the showAll mode by clicking the checkbox*/
	        var rowCheckboxClicked = function rowCheckboxClicked(rowIsActive) {
	          console.log('toggled row: ' + row.questionRow.key);
	          row.checked = rowIsActive;
	          if (!rowIsActive) {
	            (row.questionRow.questions || []).forEach(function (question) {
	              delete question.answer;
	            });
	            _this2.removeQuestionRowValues(row.questionRow);
	          }
	          _this2.saveQuestionRows(activeRows.filter(function (r) {
	            return r.checked;
	          }));
	          _this2.setState({
	            activeRows: [].concat((0, _toConsumableArray3.default)(activeRows))
	          });
	        };
	        /*A questions value has been changed*/
	        var questionChanged = function questionChanged(questionKey, answer, passedValidation) {
	          row.questionRow.questions.find(function (question) {
	            return question.key === questionKey;
	          }).answer = answer;
	          row.questionRow.questions.find(function (question) {
	            return question.key === questionKey;
	          }).validForUpdate = passedValidation;
	          _this2.setState({
	            activeRows: [].concat((0, _toConsumableArray3.default)(activeRows))
	          });
	
	          //call debounce function to save whole row of answers
	          _this2.saveQuestionBuilderValues();
	        };
	        return row.questionRow ? _react2.default.createElement(_QuestionRow.ActiveQuestionRow, (0, _extends3.default)({}, row, {
	          key: index,
	          onChange: questionChanged,
	          onRemove: rowRemoved,
	          isToggle: row.questionRow.key === toggle,
	          showAllMode: showAllRows,
	          onChecked: rowCheckboxClicked
	        })) : _react2.default.createElement(_QuestionRow.QuestionRowSelector, {
	          key: index,
	          availableRows: availableRowOptions,
	          onChange: rowAdded,
	          onRemove: rowRemoved,
	          disableRemove: index === 0 && activeRows.length === 1
	        });
	      });
	
	      var classes = (0, _classnames2.default)({
	        'questionBuilder-panel': true
	      });
	
	      var toggleSelected = activeRows.find(function (_ref2) {
	        var _ref2$questionRow = _ref2.questionRow,
	            questionRow = _ref2$questionRow === undefined ? {} : _ref2$questionRow;
	        return questionRow.key === toggle;
	      });
	
	      var newButton = activeRows.length < questionRows.filter(function (r) {
	        return r.key !== toggle;
	      }).length && !toggleSelected && !showAllRows ? _react2.default.createElement(
	        'div',
	        { className: 'text-center' },
	        _react2.default.createElement(
	          'button',
	          { className: 'btn btn-secondary new', onClick: this.addRow },
	          _react2.default.createElement(_reactIntl.FormattedMessage, _MessageDefinitions2.default.addRow),
	          _react2.default.createElement(_reactFontawesome2.default, { name: 'plus' })
	        )
	      ) : null;
	
	      return _react2.default.createElement(
	        'div',
	        { className: classes },
	        renderedQuestionRows,
	        newButton
	      );
	    }
	  }]);
	  return QuestionBuilder;
	}(_react2.default.Component), _class.propTypes = {
	  groupKey: _propTypes2.default.string.isRequired,
	  toggle: _propTypes2.default.string,
	  showAllRows: _propTypes2.default.bool
	}, _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.addRow = function () {
	    _this3.setState({
	      activeRows: [].concat((0, _toConsumableArray3.default)(_this3.state.activeRows), [{}])
	    });
	  };
	
	  this.saveQuestionRows = function (rows) {
	    var questionRows = rows.filter(function (r) {
	      return r.questionRow;
	    }).map(function (r) {
	      return r.questionRow.key;
	    });
	    var groupKey = _this3.props.groupKey;
	
	    _this3.props.answerService.saveAnswer({
	      appkey: groupKey,
	      value: questionRows,
	      timestamp: new Date()
	    });
	  };
	
	  this.removeQuestionRowValues = function () {
	    var questionRow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    (questionRow.questions || []).forEach(function (question) {
	      _this3.props.answerService.removeAnswer(questionRow.key + '_' + question.key);
	    });
	  };
	
	  this.saveQuestionBuilderValues = (0, _lodash2.default)(function () {
	    var updatedRows = _this3.state.activeRows.map(function (row) {
	      if (row.hasOwnProperty('questionRow')) {
	        (row.questionRow.questions || []).map(function (question) {
	          if (question.hasOwnProperty('validForUpdate')) {
	            if (question.validForUpdate) {
	              _this3.props.answerService.saveAnswer({
	                appkey: row.questionRow.key + '_' + question.key,
	                value: question.answer,
	                timestamp: new Date()
	              });
	              console.log('answer saved to service: ' + question.answer + ' for ' + row.questionRow.key + '_' + question.key);
	            } else {
	              _this3.props.answerService.removeAnswer(row.questionRow.key + '_' + question.key);
	            }
	            delete question.validForUpdate;
	          }
	          return question;
	        });
	      }
	      return row;
	    });
	
	    _this3.setState({
	      activeRows: updatedRows
	    });
	  }, 500);
	}, _temp);
	exports.default = QuestionBuilder;
	module.exports = exports['default'];

/***/ },

/***/ 680:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActiveQuestionRow = exports.QuestionRowSelector = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MessageDefinitions = __webpack_require__(96);
	
	var _MessageDefinitions2 = _interopRequireDefault(_MessageDefinitions);
	
	var _reactIntl = __webpack_require__(10);
	
	var _reactFontawesome = __webpack_require__(31);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _SpinnerQuestion = __webpack_require__(684);
	
	var _SpinnerQuestion2 = _interopRequireDefault(_SpinnerQuestion);
	
	var _DropdownQuestion = __webpack_require__(682);
	
	var _DropdownQuestion2 = _interopRequireDefault(_DropdownQuestion);
	
	var _RadioQuestion = __webpack_require__(683);
	
	var _RadioQuestion2 = _interopRequireDefault(_RadioQuestion);
	
	var _CheckboxQuestion = __webpack_require__(681);
	
	var _CheckboxQuestion2 = _interopRequireDefault(_CheckboxQuestion);
	
	var _BuildOptions = __webpack_require__(181);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var questionComponents = {
	  spinner: _SpinnerQuestion2.default,
	  dropdown: _DropdownQuestion2.default,
	  radio: _RadioQuestion2.default,
	  checkbox: _CheckboxQuestion2.default
	};
	
	var QuestionRowSelector = function QuestionRowSelector(_ref) {
	  var _ref$availableRows = _ref.availableRows,
	      availableRows = _ref$availableRows === undefined ? [] : _ref$availableRows,
	      onChange = _ref.onChange,
	      onRemove = _ref.onRemove,
	      _ref$disableRemove = _ref.disableRemove,
	      disableRemove = _ref$disableRemove === undefined ? false : _ref$disableRemove;
	
	  var goalOptions = (0, _BuildOptions.BuildSelectOptions)(availableRows);
	
	  var typeChanged = function typeChanged(event) {
	    onChange(event.target.value);
	  };
	
	  var removeButton = !disableRemove ? _react2.default.createElement(
	    'button',
	    { className: 'btn btn-link remove', onClick: onRemove },
	    _react2.default.createElement(_reactFontawesome2.default, { name: 'trash-o' })
	  ) : null;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'question-row' },
	    _react2.default.createElement(
	      'div',
	      { className: 'question-cell' },
	      _react2.default.createElement(
	        'label',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, _MessageDefinitions2.default.prompt)
	      ),
	      _react2.default.createElement(
	        'select',
	        { className: 'form-control', onChange: typeChanged, value: '' },
	        _react2.default.createElement(
	          'option',
	          { value: '' },
	          'Please select'
	        ),
	        goalOptions
	      )
	    ),
	    removeButton
	  );
	};
	
	//TODO: Enhanced validation
	var ActiveQuestionRow = function ActiveQuestionRow(_ref2) {
	  var questionRow = _ref2.questionRow,
	      onChange = _ref2.onChange,
	      onRemove = _ref2.onRemove,
	      onChecked = _ref2.onChecked,
	      _ref2$checked = _ref2.checked,
	      checked = _ref2$checked === undefined ? false : _ref2$checked,
	      _ref2$showAllMode = _ref2.showAllMode,
	      showAllMode = _ref2$showAllMode === undefined ? false : _ref2$showAllMode,
	      _ref2$isToggle = _ref2.isToggle,
	      isToggle = _ref2$isToggle === undefined ? false : _ref2$isToggle;
	  var rowKey = questionRow.key,
	      rowValue = questionRow.value,
	      _questionRow$question = questionRow.questions,
	      questions = _questionRow$question === undefined ? [] : _questionRow$question;
	
	
	  var renderedQuestions = !showAllMode && !isToggle || showAllMode && checked ? questions.filter(function (question) {
	    return question.type;
	  }).map(function (question, index) {
	    var key = question.key,
	        value = question.value,
	        type = question.type,
	        answer = question.answer,
	        _question$attributes = question.attributes,
	        attributes = _question$attributes === undefined ? {} : _question$attributes;
	
	    var answers = question.answers ? question.answers : [];
	    var Component = questionComponents[type];
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'question-cell', key: key },
	      _react2.default.createElement(
	        'label',
	        null,
	        value
	      ),
	      _react2.default.createElement(Component, {
	        rowKey: rowKey,
	        questionKey: key,
	        answers: answers,
	        attributes: attributes,
	        valueChanged: onChange,
	        answer: answer
	      })
	    );
	  }) : null;
	
	  var checkBoxClicked = function checkBoxClicked(e) {
	    var box = document.getElementById(e.target.id);
	    onChecked(box.checked);
	  };
	
	  var questionRowCheckbox = showAllMode ? _react2.default.createElement('input', { className: 'custom-control-input checkbox', type: 'checkbox', id: rowKey, onChange: checkBoxClicked, checked: checked }) : null;
	
	  var removeButton = showAllMode ? null : _react2.default.createElement(
	    'button',
	    { className: 'btn btn-link remove', onClick: onRemove },
	    _react2.default.createElement(_reactFontawesome2.default, { name: 'trash-o' })
	  );
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'question-row ' + rowKey },
	    _react2.default.createElement(
	      'div',
	      { className: 'question-cell row-key' },
	      _react2.default.createElement(
	        'label',
	        null,
	        questionRowCheckbox,
	        _react2.default.createElement(_reactIntl.FormattedMessage, _MessageDefinitions2.default.prompt)
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'form-control form-control-plaintext' },
	        rowValue
	      )
	    ),
	    renderedQuestions,
	    removeButton
	  );
	};
	
	exports.QuestionRowSelector = QuestionRowSelector;
	exports.ActiveQuestionRow = ActiveQuestionRow;

/***/ },

/***/ 681:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BuildOptions = __webpack_require__(181);
	
	var _MessageDefinitions = __webpack_require__(96);
	
	var _MessageDefinitions2 = _interopRequireDefault(_MessageDefinitions);
	
	var _reactIntl = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CheckboxQuestion = function CheckboxQuestion(_ref) {
	  var rowKey = _ref.rowKey,
	      questionKey = _ref.questionKey,
	      _ref$answers = _ref.answers,
	      answers = _ref$answers === undefined ? [] : _ref$answers,
	      valueChanged = _ref.valueChanged,
	      answer = _ref.answer;
	
	
	  var validateThenUpdate = function validateThenUpdate(e) {
	    var checkboxes = document.getElementsByName(e.target.name);
	    var checked = [];
	    checkboxes.forEach(function (box) {
	      return box.checked ? checked.push(box.value) : null;
	    });
	    valueChanged(questionKey, checked, !!checked.length);
	  };
	
	  var checkboxOptions = (0, _BuildOptions.BuildCheckboxOptions)(answers, rowKey, questionKey, validateThenUpdate, answer);
	
	  var displayError = function displayError(value) {
	    var message = false;
	    if (!value || !value.length) {
	      message = _react2.default.createElement(_reactIntl.FormattedMessage, _MessageDefinitions2.default.validationRequired);
	    }
	    return message ? _react2.default.createElement(
	      'div',
	      { className: 'invalid-feedback' },
	      message
	    ) : null;
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'builderOption-answer checkbox-section' },
	    checkboxOptions,
	    displayError(answer)
	  );
	};
	
	CheckboxQuestion.propTypes = {
	  questionKey: _react2.default.PropTypes.string.isRequired,
	  answers: _react2.default.PropTypes.array,
	  valueChanged: _react2.default.PropTypes.func,
	  label: _react2.default.PropTypes.string,
	  answer: _react2.default.PropTypes.array
	};
	
	exports.default = CheckboxQuestion;
	module.exports = exports['default'];

/***/ },

/***/ 682:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BuildOptions = __webpack_require__(181);
	
	var _MessageDefinitions = __webpack_require__(96);
	
	var _MessageDefinitions2 = _interopRequireDefault(_MessageDefinitions);
	
	var _reactIntl = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DropdownQuestion = function DropdownQuestion(_ref) {
	  var questionKey = _ref.questionKey,
	      _ref$answers = _ref.answers,
	      answers = _ref$answers === undefined ? [] : _ref$answers,
	      valueChanged = _ref.valueChanged,
	      answer = _ref.answer;
	
	
	  var validateThenUpdate = function validateThenUpdate(e) {
	    valueChanged(questionKey, e.target.value, !!e.target.value);
	  };
	
	  var selectOptions = (0, _BuildOptions.BuildSelectOptions)(answers);
	
	  var displayError = function displayError(value) {
	    var message = false;
	    if (!value) {
	      message = _react2.default.createElement(_reactIntl.FormattedMessage, _MessageDefinitions2.default.validationRequired);
	    }
	    return message ? _react2.default.createElement(
	      'div',
	      { className: 'invalid-feedback' },
	      message
	    ) : null;
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'builderOption-answer dropdown-section' },
	    _react2.default.createElement(
	      'select',
	      { id: questionKey, className: 'form-control', onChange: validateThenUpdate, value: answer ? answer : "" },
	      _react2.default.createElement(
	        'option',
	        { value: '' },
	        'Please select'
	      ),
	      selectOptions
	    ),
	    displayError(answer)
	  );
	};
	
	DropdownQuestion.propTypes = {
	  questionKey: _react2.default.PropTypes.string.isRequired,
	  answers: _react2.default.PropTypes.array,
	  valueChanged: _react2.default.PropTypes.func,
	  label: _react2.default.PropTypes.string,
	  answer: _react2.default.PropTypes.string
	};
	
	exports.default = DropdownQuestion;
	module.exports = exports['default'];

/***/ },

/***/ 683:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BuildOptions = __webpack_require__(181);
	
	var _MessageDefinitions = __webpack_require__(96);
	
	var _MessageDefinitions2 = _interopRequireDefault(_MessageDefinitions);
	
	var _reactIntl = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RadioQuestion = function RadioQuestion(_ref) {
	  var rowKey = _ref.rowKey,
	      questionKey = _ref.questionKey,
	      _ref$answers = _ref.answers,
	      answers = _ref$answers === undefined ? [] : _ref$answers,
	      valueChanged = _ref.valueChanged,
	      answer = _ref.answer;
	
	
	  var validateThenUpdate = function validateThenUpdate(e) {
	    valueChanged(questionKey, e.target.value, !!e.target.value);
	  };
	
	  var radioOptions = (0, _BuildOptions.BuildRadioOptions)(answers, rowKey, questionKey, validateThenUpdate, answer);
	
	  var displayError = function displayError(value) {
	    var message = false;
	    if (!value) {
	      message = _react2.default.createElement(_reactIntl.FormattedMessage, _MessageDefinitions2.default.validationRequired);
	    }
	    return message ? _react2.default.createElement(
	      'div',
	      { className: 'invalid-feedback' },
	      message
	    ) : null;
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'builderOption-answer radio-section' },
	    radioOptions,
	    displayError(answer)
	  );
	};
	
	RadioQuestion.propTypes = {
	  questionKey: _react2.default.PropTypes.string.isRequired,
	  answers: _react2.default.PropTypes.array,
	  valueChanged: _react2.default.PropTypes.func,
	  label: _react2.default.PropTypes.string,
	  answer: _react2.default.PropTypes.string
	};
	
	exports.default = RadioQuestion;
	module.exports = exports['default'];

/***/ },

/***/ 684:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(54);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _maxSafeInteger = __webpack_require__(689);
	
	var _maxSafeInteger2 = _interopRequireDefault(_maxSafeInteger);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactNumberFormat = __webpack_require__(625);
	
	var _reactNumberFormat2 = _interopRequireDefault(_reactNumberFormat);
	
	var _MessageDefinitions = __webpack_require__(96);
	
	var _MessageDefinitions2 = _interopRequireDefault(_MessageDefinitions);
	
	var _reactIntl = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SpinnerQuestion = function SpinnerQuestion(_ref) {
	  var questionKey = _ref.questionKey,
	      _ref$answers = _ref.answers,
	      answers = _ref$answers === undefined ? [] : _ref$answers,
	      valueChanged = _ref.valueChanged,
	      attributes = _ref.attributes,
	      answer = _ref.answer;
	
	
	  var validateThenUpdate = function validateThenUpdate(e, _ref2) {
	    var floatValue = _ref2.floatValue;
	
	    var min = attributes.min ? attributes.min : 0;
	    var max = attributes.max || _maxSafeInteger2.default;
	    var valueInBetween = !isNaN(floatValue) && floatValue >= min && floatValue <= max;
	    valueChanged(questionKey, floatValue, valueInBetween);
	  };
	
	  var displayError = function displayError(value) {
	    var min = attributes.min ? attributes.min : 0;
	    var message = false;
	
	    if (!value && value !== 0) {
	      message = _react2.default.createElement(_reactIntl.FormattedMessage, _MessageDefinitions2.default.validationRequired);
	    } else if (attributes.max && (value < min || value > attributes.max)) {
	      message = _react2.default.createElement(_reactIntl.FormattedMessage, (0, _extends3.default)({}, _MessageDefinitions2.default.validationBetween, { values: { min: min, max: attributes.max } }));
	    } else if (value < min) {
	      message = _react2.default.createElement(_reactIntl.FormattedMessage, (0, _extends3.default)({}, _MessageDefinitions2.default.validationMinimum, { values: { min: min } }));
	    }
	    return message ? _react2.default.createElement(
	      'div',
	      { className: 'invalid-feedback' },
	      message
	    ) : null;
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'builderOption-answer spinner-section' },
	    _react2.default.createElement(_reactNumberFormat2.default, {
	      id: questionKey,
	      className: 'answer form-control',
	      value: answer,
	      thousandSeparator: true,
	      prefix: attributes.type === 'currency' ? '$' : '',
	      decimalPrecision: 0,
	      onChange: validateThenUpdate
	    }),
	    displayError(answer)
	  );
	};
	
	SpinnerQuestion.propTypes = {
	  questionKey: _react2.default.PropTypes.string.isRequired,
	  answers: _react2.default.PropTypes.array,
	  valueChanged: _react2.default.PropTypes.func,
	  label: _react2.default.PropTypes.string,
	  answer: _react2.default.PropTypes.number
	};
	
	exports.default = SpinnerQuestion;
	module.exports = exports['default'];

/***/ },

/***/ 689:
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(699), __esModule: true };

/***/ },

/***/ 699:
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(731);
	module.exports = 0x1fffffffffffff;


/***/ },

/***/ 731:
[1456, 32]

});


/** WEBPACK FOOTER **
 ** question-builder.min.js
 **/